import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { useTheme } from "@mui/material";
import './knowledgeAudit.css'
import {
  addDetailsAPI,
  botProfilesAPI,
  publishDetailsAPI,
  updateDetailsAPI,
} from "./utils/constants";
import dayjs from "dayjs";
import EditDetails from "./popups/editDetails";
import { useKBState } from "./customHooks/useKBState";
import * as XLSX from "xlsx";
import { appConfig } from "../../../utils/app.config";
import CryptoJS from "crypto-js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import KnowledgeAuditDashboard from "./knowledgeAuditDashboard";
import { width } from "@mui/system";

interface KBArticle {
  Article_State: string;
  Article_Title: string;
  Usage_Views: string;
  Helpful_Votes: string;
  Last_Updated: string;
  Created_By: string;
  ["KB Article Content_Text"]: string;
  ["KB Article Content_Html"]: string;
  Category: string;
  Subcategory: string;
  Article_ID: string;
  Schema: string;
}

// type RefsType = {
//     userIssue: (HTMLParagraphElement | null)[][];
//     workNotes: (HTMLParagraphElement | null)[][];
//     resolutionNotes: (HTMLParagraphElement | null)[][];
//     botResolution: (HTMLParagraphElement | null)[][];
//     publishedContent: (HTMLParagraphElement | null)[][];
// };

// export const formatDate = (
//     date?: string | Date,
//     format: string = "YYYY-MM-DD"
// ): string => {
//     return dayjs(date || new Date()).format(format);
// };

let hasFetched = false;

const KnowledgeAudit: React.FC = () => {

  const { val, setVal } = useKBState();
  const [popupTitle, setPopupTitle] = useState(" ");

  const [searchText, setSearchText] = useState("");

  const theme = useTheme();
  const color = theme.palette.mode;
  const [articles, setArticles] = useState<KBArticle[]>([]);
  const [publishedContent, setPublishedContent] = useState<any | {}>({});
  const [pageLoader, setPageLoader] = useState(false);
  const [updatingLoader, setUpdatingLoader] = useState(null);
  //   const articles = useSelector((store: any) => store.learning.KBDetails);
  const dispatch = useDispatch();

  const [webSocket, setWebSocket] = useState<WebSocket | null>(null);

  const randomKey = CryptoJS.lib.WordArray.random(24);
  const sessionId = randomKey.toString(CryptoJS.enc.Hex);;

  const apiUrl = `${appConfig.baseUrl}/gwt/api/v2.0/litebot/admin/session/kb/audit`;
  const apiUrl1 = `${appConfig.baseUrl}/gwt/api/v2.0/litebot/admin/session/active/kb/${sessionId}`
  let wsProtocol = appConfig.baseUrl.startsWith('https://') ? 'wss' : 'ws';


  const [modifiedContent, setModifiedContent] = useState("");
  const [actionOption, setActionOption] = useState("Publish");
  const [isActive, setIsActive] = useState(true);


  const fetchPublishedContent = async () => {
    try {

      const formData = new FormData();
      formData.append("actions", "get_all_data");
      formData.append("method", "GET");
      const options = {
        method: "POST",
        body: formData,
      };

      const response = await (await fetch(appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi", options)).json()
      if (response) {
        const map: any = {};
        for (const item of response) {
          map[item.number] = item.content
        }

        setPublishedContent(map);
        setUpdatingLoader(null);
      }
    } catch (error) {

    }
  }

  const getKbAuditData = async () => {
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        console.log("inside apiurl in ka")
        if (Array.isArray(data)) {
          console.log('if works')
          setArticles(data);
        } else if (data && Array.isArray(data.items)) {
          console.log('if else works')
          setArticles(data.items);
        } else {
          setArticles([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching KB articles:", err);
        setArticles([]);
      })
      .finally(() => {
        // Stop loader regardless of success or error
        setPageLoader(false);
      });
  };

  const deletePublishedKb = async (number: any) => {
    try {
      const formData = new FormData();
      formData.append("actions", "delete_kb");
      formData.append("method", "DELETE");
      formData.append("kb_number", number);
      const options = {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        // body: JSON.stringify({
        //   "kb_number": number
        // }),
        body: formData
      };
      const result = await (await fetch(`${updateDetailsAPI}`, options)).json();
      if (result) {
        return result;
      } else {
      }
    } catch (error) { }
  }

  const deleteKbAuditData = async (number: any) => {
    try {
      const options = {
        method: "POST",
      };
      const response = await (await fetch(apiUrl + `/${number}`, options)).json();
      console.log('fetched response', response);
      if (response) {
        return response;
      }
    } catch (error) {

    }
  }

  const handleUpdate = async (action: any, index: any, ai_ready_content: any, number: any) => {
    if (action.toLowerCase() === 'publish') {
      try {
        setUpdatingLoader(index);
        const bodyData = {
          actions: "update_kb",
          method: "POST",
          kbNumber: number,
          kbtext: modifiedContent === "" ? ai_ready_content : modifiedContent
        }
        console.log("bodyData", bodyData);

        // const formData = new FormData();
        // formData.append("actions", "update_kb");
        // formData.append("method", "POST");
        // formData.append("kbNumber", number);
        // formData.append("kbtext", modifiedContent === "" ? ai_ready_content : modifiedContent);

        // console.log("formData", formData);

        // const options = {
        //   method: "POST",
        //   body: formData,
        // };
        // const result = await (await fetch(appConfig.baseUrl + "/gwt/api/v2.0/litebot/admin/session/updatePublishContent", options)).json();

        const result = await fetch(`${appConfig.baseUrl}/gwt/api/v2.0/litebot/admin/session/updatePublishContent`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyData),
        });
        if (result) {
          console.log("get update kb result", result);
          fetchPublishedContent();
          // await getKbAuditData()
          setTimeout(() => {
            setUpdatingLoader(null);
          }, 3000);

        } else {
        }
      } catch (error) { }

    }
    else if (action.toLowerCase() === 'retire') {
      setUpdatingLoader(index);
      // getting result from bot resolution and get publish api
      const [deleteKbAuditDataResult, deletePublishedKbResult] = await Promise.all([
        deleteKbAuditData(number),
        deletePublishedKb(number),
      ]);
      if (deleteKbAuditDataResult && deletePublishedKbResult) {
        setUpdatingLoader(null);
        getKbAuditData();
      }
    }
    else if (action.toLowerCase() === 'approval') {
    }

  };


  useEffect(() => {
    setPageLoader(true);
    getKbAuditData();
  }, []);

  // useEffect(() => {
  //   if (articles.length === 0) return;
  //   getKbAuditData();
  // }, [articles])

  const url = appConfig.baseUrl.replace("http://", "").replace("https://", "");

  const [isUpdating, setIsUpdating] = useState(false);
  const establishWebSocketConnection = () => {
    const ws = new WebSocket(`${wsProtocol}://${url}/api/channels/stream/v1.0?conversationId=${sessionId}`);

    const timeout = setTimeout(() => {
      console.warn("WebSocket timeout");
      setIsUpdating(false);
      setPageLoader(false);
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    }, 17*60000);
    ws.onopen = () => {
      console.log("WebSocket connection established.");

      fetch(apiUrl1).then((res) => {
        if(!res.ok) {
          throw new Error("Audit API Failed");
        }
      })

        .catch((err) => {
          console.error("Error fetching articles:", err);
          setArticles([]);
          clearTimeout(timeout);
          setIsUpdating(false);
        })

    };

    ws.onmessage = (event) => {
        clearTimeout(timeout);
        try {
          console.log('event', event);
          const message = JSON.parse(event.data);
          console.log('pMESS', message);
          setPageLoader(false);
          if (message) {
            getKbAuditData();
          }
        } catch (err) {
          console.error(err);
        } finally {
          setIsUpdating(false);
          if (ws.readyState === WebSocket.OPEN) {
            ws.close();
          }
        }
    };


    ws.onerror = (error) => {
      clearTimeout(timeout);
      console.error("webSocket error : " , error);
      setIsUpdating(false);
      setPageLoader(false);
    }

    ws.onclose = () => {
      clearTimeout(timeout);
      console.log("WebSocket connection closed.");
      setIsUpdating(false);
    };

    setWebSocket(ws);
  };

  // const runAuditApi = async () => {
  //   try {
  //     const token = sessionStorage.getItem("cva.jwt.access.token");
  //     if (!token) throw new Error("User is not authenticated.");

  //     const response = await fetch(
  //       `${appConfig.baseUrl}/gwt/api/v2.0/litebot/admin/session/active/kb/B0001`,
  //       {
  //         method: "GET", // change to GET if your backend expects GET
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Audit API failed");
  //     }

  //     const result = await response.json();
  //     console.log("Audit API response:", result);

  //     // Refresh KB data after audit completes
  //     await getKbAuditData();
  //   } catch (error) {
  //     console.error("Error running audit:", error);
  //   } finally {
  //     //  ALWAYS stop loader
  //     setIsUpdating(false);
  //   }
  // };

  const handleUpdateClick = async () => {
    setIsUpdating(true);
  
    let pollInterval:any;
  
    try {
      await fetch(apiUrl1); // triggers the job
    } catch (err) {
      console.error('Failed to trigger audit:', err);
      setIsUpdating(false);
      return;
    }
  
    pollInterval = setInterval(async () => {
      try {
        const res = await fetch(`${appConfig.baseUrl}/gwt/api/v2.0/litebot/admin/session/active/kb/status/${sessionId}`);
        const data = await res.json();
        console.log('Data :' ,data);
        console.log('Polled the status');
        if (data.status === "success" || data.status === "error") {
          clearInterval(pollInterval);
          clearTimeout(failSafeTimer);
          setIsUpdating(false);
          if (data.status === "success") getKbAuditData();
          else console.error('Audit failed:', data.message);
        }
      } catch (err) {
        console.error('Status poll failed:', err);
      }
    }, 5*60*1000);
  
    const failSafeTimer = setTimeout(() => {
      clearInterval(pollInterval);
      setIsUpdating(false);
      console.warn('Audit fail-safe triggered — no completion status received in time.');
    }, 20 * 60 * 1000);
  };
 


  console.log("articles", articles);
  const filteredArticles = articles.filter((item: any) => {
    const search = searchText.toLowerCase();

    return (
      item.Article_ID?.toLowerCase().includes(search) ||
      item.Article_Title?.toLowerCase().includes(search) ||
      item.Category?.toLowerCase().includes(search) ||
      item.Subcategory?.toLowerCase().includes(search) ||
      item.Article_State?.toLowerCase().includes(search) ||
      item.Created_By?.toLowerCase().includes(search)
    );
  });
  const [currPage, setCurrPage] = useState(1);
  const rowsPerPage = 5;

  const totalRows = filteredArticles.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const startIndex = (currPage - 1) * rowsPerPage;
  const currentRows = filteredArticles.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  const chngePage = (page: number) => {
    if (page >= 1 && page <= totalPages) setCurrPage(page);
  };

  // Render single page button
  const renderPageButton = (page: number) => (
    <li key={page} className={`page-item ${currPage === page ? "active" : ""}`}>
      <button
        className="page-link"
        style={{ width: "38px", height: '38px', fontSize: "14px" }}
        onClick={() => chngePage(page)}
      >
        {page}
      </button>
    </li>
  );

  // Render page numbers with ellipses
  const renderPageNumbers = (): JSX.Element[] => {
    const pages: JSX.Element[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(renderPageButton(i));
      }
    } else {
      pages.push(renderPageButton(1));

      if (currPage > 3) {
        pages.push(
          <li className="page-item disabled" key="start-ellipsis">
            <button className="page-link">...</button>
          </li>
        );
      }

      const middlePages: number[] = [];
      if (currPage <= 3) {
        middlePages.push(2, 3, 4);
      } else if (currPage > totalPages - 2) {
        middlePages.push(totalPages - 3, totalPages - 2, totalPages - 1);
      } else {
        middlePages.push(currPage - 1, currPage, currPage + 1);
      }

      middlePages.forEach((page) => {
        if (page > 1 && page < totalPages) {
          pages.push(renderPageButton(page));
        }
      });

      if (currPage < totalPages - 2) {
        pages.push(
          <li className="page-item disabled" key="end-ellipsis">
            <button className="page-link">...</button>
          </li>
        );
      }

      pages.push(renderPageButton(totalPages));
    }

    return pages;
  };

  const toggleBtns = () => {
    setIsActive(!isActive)
  }

  const valueOrDefault = (value:any) => value === null || value === undefined || value === "" ? "Not Available" : value;

  const htmlContent = Array.isArray(val.transcript)
  ? val.transcript.join("")
  : val.transcript || "";

  return (
    <div className="d-flex flex-column h-100" >
      <div className="d-flex justify-content-end ms-2 me-2">
        {!isActive && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "auto" }}>
            <button
              className="btn btn-primary"
              onClick={handleUpdateClick}
              disabled={isUpdating}
            >
              {isUpdating ? "Auditing..." : "Run Audit"}
            </button>
          </div>
        )}

        <div className="d-flex">
          <button type="button" onClick={toggleBtns} className={`btn btn-${isActive ? 'primary pe-none' : ''} d-flex justify-content-center align-items-center ka-toggle-switch`}>
            <i className={`bi bi-grid-1x2 ${isActive ? 'text-white' : ''}`}></i>
          </button>
          <button type="button" onClick={toggleBtns} className={`btn btn-${isActive ? '' : 'primary pe-none'} d-flex justify-content-center align-items-center ka-toggle-switch`}>
            <i className={`bi bi-list-task ${isActive ? '' : 'text-white'}`}></i>
          </button>
        </div>

      </div>
      {
        isActive ? (
          <KnowledgeAuditDashboard color={color} />)
          : !pageLoader ? (
            articles && articles.length !== 0 ? (
              <div className="p-2">
                {/* <h2 className="text-xl font-bold mb-4 sticky top-0 z-10">Knowledge Audit Agent</h2> */}
                {/* Filters Row */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "350px" }}
                        placeholder="Search Article ID, Title, Category, Author..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrPage(1);
                        }}
                      />
                    </div>
                <div
                  style={{
                    flex: "1",
                    overflow: "auto",
                    fontSize: "14px",
                    // border: color === "dark" ? "" : "1px solid #ededed",
                  }}
                  className=" rounded-2"
                  data-bs-theme={`${color}`}
                >
                  <div
                    className="rounded-2"
                    style={{
                      maxHeight: "500px",
                      overflowY: "auto",
                    }}
                  >
                    <table
                      className="table table-striped table-hover learning-table"
                      style={{ marginBottom: "0px", marginTop: "0px " }}
                    >
                      <thead
                        className={`${color === "dark" ? "table-light" : "table-dark"
                          }`}
                      >
                        <tr>
                          <th
                            className="sticky-header sticky-col"
                            style={{
                              whiteSpace: "nowrap",
                              width: "80px", // Set a fixed width
                              minWidth: "80px", // Ensure it doesn't shrink
                              position: "sticky", // Explicitly set position
                              left: "0", // Stays at the far left
                            }}
                          >
                            &nbsp;Article ID&nbsp;
                          </th>
                          <th
                            className="sticky-header sticky-col"
                            style={{
                              whiteSpace: "nowrap",
                              width: "fit-content",
                              position: "sticky",
                              left: "80px", // Starts exactly after the 1st column (80px)
                            }}
                          >
                            &nbsp;Short Description&nbsp;
                          </th>
                          <th
                            className=" sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Article Entity &nbsp;
                          </th>
                          <th
                            className=" sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Category&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Domain&nbsp;
                          </th>

                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;KB Article Content&nbsp;
                          </th>
                          {/* <th
                                    className="sticky-header"
                                    style={{ whiteSpace: "nowrap", width: "fit-content" }}
                                >
                                    &nbsp;Approval Status&nbsp;
                                </th> */}
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Article State&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Usage (Views)&nbsp;
                          </th>

                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Helpful Votes&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Created&nbsp;
                          </th>
                          {/* <th
                                    className="sticky-header"
                                    style={{ whiteSpace: "nowrap", width: "fit-content" }}
                                >
                                    &nbsp;Unhelpful Votes&nbsp;
                                </th> */}
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Last Updated&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Author&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Readability Score&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Structuring Score&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Search Optimization Score&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI KB Quality Score&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Quality Score Details&nbsp;
                          </th>
                          {/* <th
                                    className="sticky-header"
                                    style={{ whiteSpace: "nowrap", width: "fit-content" }}
                                >
                                    &nbsp;Ai Duplicate Flag&nbsp;
                                </th> */}
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Audit Remarks&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI-Ready Content&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;AI Tags&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Reviewer Modifications&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Action Option&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Action&nbsp;
                          </th>
                          <th
                            className="sticky-header"
                            style={{ whiteSpace: "nowrap", width: "fit-content" }}
                          >
                            &nbsp;Published Content&nbsp;
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "black", height: "60px" }}>
                        {currentRows?.map((data: any, index: any) => (
                          <tr>
                            <td
                              className="sticky-col"
                              style={{
                                position: "sticky",
                                left: "0",
                                minWidth: "80px",
                                zIndex: "11",
                              }}
                            >
                              {data.Article_ID}
                            </td>
                            <td
                              className="sticky-col"
                              style={{
                                position: "sticky",
                                left: "80px",
                                zIndex: "10",
                              }}
                            >
                              {data.Article_Title}
                            </td>
                            <td>{valueOrDefault(data.AI_Article_Entity)}</td>
                            <td>{valueOrDefault(data.Category)}</td>
                            <td>{valueOrDefault(data.Subcategory)}</td>
                            {/* <td><div dangerouslySetInnerHTML={{ __html: data["KB Article Content_Html"] }} /></td> */}
                            {/* <td > Approved</td> */}
                            <td
                              style={{
                                padding: "10px",
                                textAlign: "center",
                                // verticalAlign: 'middle'

                              }}
                            >
                              <div>
                                <i
                                  className="bi bi-eye-fill"
                                  style={{ cursor: "pointer", fontSize: '20px' }}
                                  onClick={() => {
                                    const cleanText =( data["KB_Article_Content_Html"] || '').replace(/src="\/sys_attachment\.do/g,'src="https://warwickdev.service-now.com/sys_attachment.do');
                                    setPopupTitle("KB Article Content");
                                    setVal({
                                      ...val,
                                      openTranscript: true,
                                      transcript: cleanText,
                                    })
                                  }

                                  }
                                ></i>
                              </div>
                            </td>
                            <td>{data.Article_State}</td>
                            <td style={{ textAlign: "center" }}>{data.Usage_Views}</td>
                            <td style={{ textAlign: "center" }} >{data.Helpful_Votes}</td>
                            <td>{data.Created}</td>
                            {/* <td > </td> */}
                            <td>{data.Last_Updated}</td>
                            <td>{data.Created_By}</td>
                            <td>{data.AI_Readability_Score}</td>
                            <td style={{ textAlign: "center" }}>{valueOrDefault(data.AI_Structuring_Score)}</td>
                            <td style={{ textAlign: "center" }}>{valueOrDefault(data.AI_Search_Optimization_Score)}</td>
                            <td style={{ textAlign: "center" }}>{valueOrDefault(data.AI_KB_Quality_Score)}</td>
                            {/* <td>{data.AI_Quality_Score_details}</td> */}
                            <td
                              style={{
                                padding: "10px",
                                textAlign: "center",
                                // verticalAlign: 'middle'

                              }}
                            >
                              <div>
                                <i
                                  className="bi bi-eye-fill"
                                  style={{ cursor: "pointer", fontSize: '20px' }}
                                  onClick={() => {
                                    setPopupTitle("KB Quality Score Details");
                                    setVal({
                                      ...val,
                                      openTranscript: true,
                                      transcript: data.AI_Quality_Score_details,
                                    })
                                  }

                                  }
                                ></i>
                              </div>
                            </td>
                            {/* <td>{data.AI_Audit_Remarks}</td> */}
                            <td
                              style={{
                                padding: "10px",
                                textAlign: "center",
                                // verticalAlign: 'middle'

                              }}
                            >
                              <div>
                                <i
                                  className="bi bi-eye-fill"
                                  style={{ cursor: "pointer", fontSize: '20px' }}
                                  onClick={() => {
                                    setPopupTitle("AI Audit Remarks");
                                    setVal({
                                      ...val,
                                      openTranscript: true,
                                      transcript: data.AI_Audit_Remarks,
                                    })
                                  }

                                  }
                                ></i>
                              </div>
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                textAlign: "center",
                                // verticalAlign: 'middle'

                              }}
                            >
                              <div>
                                <i
                                  className="bi bi-eye-fill"
                                  style={{ cursor: "pointer", fontSize: '20px' }}
                                  onClick={() => {
                                    setPopupTitle("AI Ready Content ");
                                    setVal({
                                      ...val,
                                      openTranscript: true,
                                      transcript: data.AI_Ready_Content?.replace(/\\\\n/g, "\n")?.replace(/\\n/g, '\n'),
                                    })
                                  }

                                  }
                                ></i>
                              </div>
                            </td>
                            <td>{data.AI_Tags}</td>
                            <td><textarea style={{ width: "300px", height: "280px" }} onChange={(e) => setModifiedContent(e.target.value)}>{data.AI_Ready_Content?.replace(/\\\\n/g, "\n")?.replace(/\\n/g, '\n')}</textarea></td>
                            <td><select onChange={(e) => setActionOption(e.target.value)} className="form-select m-0" style={{ width: "105px" }}>
                              <option>Publish</option>
                              <option>Retire</option>
                              <option>Approval</option>
                            </select></td>
                            <td><Button style={{ marginTop: "10px", margin: 0 }}
                              disabled={updatingLoader === index ? true : false}
                              onClick={() => handleUpdate(actionOption, index, data?.AI_Ready_Content, data?.Article_ID)}>{updatingLoader === index
                                && (<div className="spinner-border me-2" style={{ height: '14px', width: '14px' }} role="status"></div>)}
                              {updatingLoader === index ? 'Updating' : 'Update'}
                            </Button></td>
                            <td><div style={{
                              width: "300px", height: "280px", overflowY: "auto",
                              overflowX: "hidden",
                              wordBreak: "break-word",
                              whiteSpace: "pre-wrap"
                            }}>{updatingLoader === index ? (
                              <p className="m-0">Loading Content...</p>
                            ) : data.published_content && data.published_content.trim() !== "" ? (
                              data.published_content?.replace(/\\\\n/g, "\n")?.replace(/\\n/g, '\n')
                            ) : (
                              " "
                            )}
                            </div></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3 ">
                  <div
                    className="d-flex justify-content-end  gap-3"
                    style={{ alignItems: "baseline" }}
                  >
                    {/* Showing info */}
                    <div style={{ fontSize: "14px", height: '38px' }}>
                      Showing {startIndex + 1} to {startIndex + currentRows.length}{" "}
                      of {totalRows} rows
                    </div>

                    {/* Pagination buttons */}
                    <nav data-bs-theme={color}>
                      <ul className="pagination mb-0 ">
                        <li
                          className={`page-item ${currPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            style={{ fontSize: "14px", height: '38px' }}
                            onClick={() => chngePage(currPage - 1)}
                          >
                            Prev
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li
                          className={`page-item ${currPage === totalPages ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            style={{ fontSize: "14px", height: '38px' }}
                            onClick={() => chngePage(currPage + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>


                  </div>

                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  height: "100%",
                }}
              >
                <i
                  className="bi bi-file-earmark-x"
                  style={{ fontSize: "30px" }}
                ></i>
                <p style={{ margin: 0 }}> No Data Available</p>
              </div>
            )
          ) : (
            <div
              style={{
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  height: "18px",
                  width: "18px",
                  marginRight: "8px",
                }}
                className="spinner-border"
                role="status"
              ></div>
            </div>
          )}

      {val.openTranscript && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
           style={{
            width: "60vw",
            maxWidth: "1400px",
            }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {popupTitle}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setVal({ ...val, openTranscript: false })}
                  aria-label="Close"
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  margin: 0,
                  color: "black",
                  maxHeight: "75vh",
                  overflowY: "auto",
                  padding: "16px",
                  }}
              >
                {val.transcript ? (
                  <div
                    className="kb-content"
                    style={{ fontSize: "14px" ,width:"100%" }}
                    dangerouslySetInnerHTML={{
                      __html: htmlContent,
                    }}
                  />
                ) : (
                  <div>No data available</div>
                )}
              </div>
              <div
                className="modal-footer"
                style={{ justifyContent: "flex-end" }}
              >
                <button
                  type="button"
                  style={{
                    width: "fit-content",
                    lineHeight: "normal",
                    height: "fit-content",
                    display: "flex",
                    gap: "8px",
                  }}
                  className="btn btn-secondary"
                  onClick={() => setVal({ ...val, openTranscript: false })}
                >
                  <i className="bi bi-x-circle"></i>
                  Close
                </button>

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KnowledgeAudit;